import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import IdFieldDetail from "./detail";
/** <b>Composant qui contient l'affichage d'un champ de type id en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Id() {
    return _jsx(_Fragment, { children: "Id" });
}
var field = fieldsType.id;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, IdFieldDetail);
